import { MultiLangString } from '../MultiLangString';
import { Cvc12ReportSectionNarrative } from './narrative-report.model';

export interface OmiSurveyAnswer {
  /** Canonical English value for matching, API payloads, and stored responses. */
  answer: MultiLangString;
  questionScore: number;
  categoryWeight: number;
  questionWeight: number;
}

export interface OmiSurveyQuestion {
  sequenceNo: number;
  category: MultiLangString;
  tag: MultiLangString;
  question: MultiLangString;
  answers: OmiSurveyAnswer[];
}

export interface OmiSurvey {
  _id: string;
  questions: OmiSurveyQuestion[];
  /** Plain-text narrative per deficit key; layout is in the survey-report component. */
  reportSections?: Partial<Record<string, Cvc12ReportSectionNarrative>>;
}

export interface OmiSurveyUserAnswer {
  questionSequenceNo: number;
  /** Must match `answer.en` for the selected option. */
  answer: string;
  calculatedScore: number;
}

export interface OmiSurveyCatScore {
  /** English category name for analytics and report logic. */
  category: string;
  score: number;
  scorePercent: number;
}

export interface OmiSurveyResponse {
  _id: string;
  surveyQuestionsId: string;
  userName: string;
  userEmail: string;
  userSex: string;
  /** ISO date string (YYYY-MM-DD) when user was born. Optional. */
  userDob?: string;
  /** ISO date string when report was created. Added for comparison over time. */
  dateTime?: string;
  answers: OmiSurveyUserAnswer[];
  score: number;
  /** Percentage based on answered questions (score / (answers.length * maxPerQuestion) * 100). */
  scorePercent: number;
  /** Per-category scores. */
  catScores: OmiSurveyCatScore[];
}

export interface CreateOmiSurveyResponseDto {
  surveyQuestionsId: string;
  userName: string;
  userEmail: string;
  userSex: string;
  /** ISO date string (YYYY-MM-DD). Optional. */
  userDob?: string;
}

export interface UpdateOmiSurveyResponseDto {
  questionSequenceNo: number;
  /** Must match the survey definition's `answer.en` for that question. */
  answer: string;
  calculatedScore: number;
}
